'use client'

import { useCallback } from 'react'
import { BroadcastPlatformEventProps, broadcastPlatformEvent } from '../helpers/broadcastPlatformEvent'

export interface UsePlatformEventBroadcastReturnValue {
    broadcast: (options: BroadcastPlatformEventProps) => void
}

/**
 * IMPORTANT!! This hook has never been used outside of POC. Be aware that it might need some tweaking before usage // TODO: remove this comment when this is no longer accurate.
 *
 * @param { scope } - the default scope to which an event should be broadcasted
 * @param { code } - the default code withing that scope to broadcast to. Example: if scope is Company, code should be the companyCode
 * @param { event } - the default event name that should be broadcasted to. for example 'address-update-pending' or 'address-updating'
 * @param { message } - the message that should be broadcasted
 *
 * @returns { broadcast } broadcast function to which no parameter have to be given. but all default parameters CAN optionally be overwritten
 */
export const usePlatformEventBroadcast = ({
    scope,
    code,
    event,
    message,
}: BroadcastPlatformEventProps): UsePlatformEventBroadcastReturnValue => {
    const broadcast = useCallback(
        (options?: BroadcastPlatformEventProps) =>
            broadcastPlatformEvent({ scope, code, event, message, ...(options ?? {}) }),
        [scope, code, event, message],
    )

    return { broadcast }
}
